import React, { useEffect } from "react";
import { useRef } from "react";
import useOutsideClick from "../../hooks/useOutsideClick";
import { MdClose } from "react-icons/md";
import ToggleTag from "../common/ToggleTag";
import { categories, projectStates } from "../../data/dataCheckboxes";
import { FiFilter } from "react-icons/fi";
const ProjectFilters = ({
  show,
  setShow,
  filter,
  setFilter,
  initialFilter,
  handleChangeCheckBox,
  handleChangeFilter,
}) => {
  const handleClose = () => {
    setShow(false);
  };
  const modalRef = useRef(null);
  useOutsideClick(modalRef, handleClose, null, show);
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  return (
    <div
      className={`w-full h-screen flex lg:hidden justify-center items-end bg-[#241b4795] backdrop-blur-md fixed top-0 left-0 z-50 roboto-font transition-all duration-300 ease-in `}
    >
      <div
        ref={modalRef}
        className="w-full h-[calc(100vh-40px)] flex flex-col justify-between gap-y-7 px-6 items-center pb-20 bg-[#F6F5FF] rounded-t-xl animated-bottom-sheet overflow-y-auto "
      >
        <div className="w-full flex justify-between pt-4 ">
          <button
            onClick={() => {
              setFilter(initialFilter);
            }}
            className="text-sm text-custom-gray-700"
          >
            Clear
          </button>
          <div className="min-w-fit flex items-center font-semibold">
            <FiFilter size={20} className="mr-1.5" color="#4d29d1" />
            Filter
          </div>
          <button onClick={handleClose} className="-mb-1">
            <MdClose className="text-custom-gray-700" size={20} />
          </button>
        </div>

        {/* -------- menu items -------- */}
        <section className="w-full h-full flex flex-col items-start gap-8 ">
          {/* Categories */}
          <div className="w-full flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <div className="w-1 h-6 bg-gradient-to-b from-primary to-primary-green rounded-full"></div>
              <h3 className="text-lg font-semibold text-secondary abel-font">Categories</h3>
            </div>
            <div className="w-full grid grid-cols-2 gap-3">
              {categories.map((item, index) => (
                <ToggleTag
                  key={item?.id + index}
                  Icon={item.icon}
                  id={item?.id}
                  title={item?.title}
                  onChange={(e) =>
                    handleChangeCheckBox(e, "category", item?.title)
                  }
                  checked={filter.category.includes(item?.title)}
                />
              ))}
            </div>
          </div>

          <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>

          {/* Project States */}
          <div className="w-full flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <div className="w-1 h-6 bg-gradient-to-b from-primary to-primary-green rounded-full"></div>
              <h3 className="text-lg font-semibold text-secondary abel-font">Project State</h3>
            </div>
            <div className="w-full flex flex-wrap gap-3">
              {projectStates?.map((state, index) => (
                <label 
                  key={state + index} 
                  className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-white border-2 border-gray-200 hover:border-primary/50 transition-all duration-200"
                >
                  <input
                    type="checkbox"
                    name="state"
                    className="w-4 h-4 accent-primary"
                    checked={filter?.projectState?.includes(state)}
                    onChange={(e) =>
                      handleChangeCheckBox(e, "projectState", state)
                    }
                  />
                  <span className="text-sm font-medium text-gray-700">{state}</span>
                </label>
              ))}
            </div>
          </div>

          <button
            onClick={handleClose}
            className="w-full text-white text-lg flex justify-center items-center bg-light-primary py-2 rounded-[10px] "
          >
            See Result
          </button>
        </section>
      </div>
    </div>
  );
};

export default ProjectFilters;
